export default function ExpiredLink({ adminEmail }) {
    const email = adminEmail 
        || import.meta.env.VITE_ADMIN_EMAIL
        || 'admin@milwaukeeballet.org';

        return (
            <div
                style={{
                    maxWidth: 560,
                    margin: '40px auto',
                    padding: '28px 24px',
                    backgroundColor: '#FFF6E0',
                    border: '1px solid #D9A441',
                    borderRadius: 8,
                }}
                role='alert'
                >
                <h2 style={{ marginTop: 0, color: '#7a4f00' }}>
                    This approval window has closed.
                </h2>
                <p style={{ lineHeight: 1.5 }}>
                    Approval links are active for 24 hours from the time they're sent.
                    Any photos you didn't respond to during that window have been 
                    automatically processed per the collective bargaining agreement.
                </p>
                <p style={{ lineHeight: 1.5 }}>
                    If you have questions about a specific photo, or if you believe this link should 
                    still be active, please contact the Milwaukee Ballet Admin: 
                </p>
                <p style={{ marginTop: 16, fontSize: 18 }}>
                    <a href={`mailto:${email}`} style={{ color: '#1F3A5F' }}>{email}</a>
                </p>
                </div>
        );
}